import { render, staticRenderFns } from "./ProductPhotoGallery.vue?vue&type=template&id=bd665c92&scoped=true&"
import script from "./ProductPhotoGallery.vue?vue&type=script&lang=js&"
export * from "./ProductPhotoGallery.vue?vue&type=script&lang=js&"
import style0 from "./ProductPhotoGallery.vue?vue&type=style&index=0&id=bd665c92&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd665c92",
  null
  
)

export default component.exports